export const CURRENT_VERSION = '2.7.11';
export const CURRENT_BUILD_DATE = '2026-10-25';
